import JdFocusTrap from './src/focus-trap.vue'

// ElementPlus 也没有对该组件做 withInstall 包装，暂时保持现状，仅解决警告问题
Object.assign(JdFocusTrap, {
    install(){}
})

export { JdFocusTrap }

export default JdFocusTrap
export * from './src/tokens'
export * from './src/utils'
